import trackAnalytics from '@gaia/utils/gaia/trackAnalytics';
import trackFormAnalytics from '@gaia/utils/gaia/trackFormAnalytics';
import trackRevenueAnalytics from '@gaia/utils/gaia/trackRevenueAnalytics';
import {getMobilePlatform} from '@gaia/utils/queryNavigator';

import {hydrate} from 'react-dom';

declare global {
    interface Window {
        gaiaReactServerHydrate: <T extends JSX.IntrinsicAttributes>(
            Component: React.ComponentType<T>,
            props: T
        ) => void;

        trackAnalytics: typeof trackAnalytics;
        trackFormAnalytics: typeof trackFormAnalytics;
        trackRevenueAnalytics: typeof trackRevenueAnalytics;
    }
}

window.gaiaReactServerHydrate = (Component, props) => {
    document.querySelector('#ssr-temporary-style')?.remove();
    hydrate(<Component {...props} />, document.querySelector('#ssr-html')!);
};

// some templates invoke `window.trackAnalytics` et al.
window.trackAnalytics = trackAnalytics;
window.trackFormAnalytics = trackFormAnalytics;
window.trackRevenueAnalytics = trackRevenueAnalytics;

switch (getMobilePlatform()) {
    case 'iOS':
        appendStylesheet('.hide-if-ios {display: none;}');
        break;
    case 'Android':
        appendStylesheet('.hide-if-android {display: none;}');
        break;
}

function appendStylesheet(body: string) {
    const styleEl = document.createElement('style');
    document.head.appendChild(styleEl);
    styleEl.appendChild(document.createTextNode(body));
}
